import { Store } from 'flummox';
import fetch from 'node-fetch';

class ContestDataStore extends Store {
  constructor(flux) {
    super();

    this.state = {
      loading: true,
      data: null
    };
    this.loadData(flux.baseUrl);
  }

  loadData(baseUrl) {
    this.ready = fetch(`${baseUrl}/files/contestData.json`).then(r => r.json());

    this.ready.then(data => {
      this.handleDataLoaded(data);
    });
  }

  handleDataLoaded(data) {
    this.setState({ data, loading: false });
  }
}

ContestDataStore.serialize = state => {
  return JSON.stringify(state);
};

ContestDataStore.deserialize = string => {
  return JSON.parse(string);
};

export default ContestDataStore;



// WEBPACK FOOTER //
// ./src/stores/ContestDataStore.js